import { useNavigate, useLocation } from 'react-router-dom'
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material'
import HomeIcon from '@mui/icons-material/Home'
import AssignmentIcon from '@mui/icons-material/Assignment'
import CampaignIcon from '@mui/icons-material/Campaign'
import UploadIcon from '@mui/icons-material/Upload'
import PersonIcon from '@mui/icons-material/Person'
const navItems = [
  { label: 'Home', path: '/influencer', icon: <HomeIcon /> },
  { label: 'My Tasks', path: '/influencer/tasks', icon: <AssignmentIcon /> },
  { label: 'My Campaigns', path: '/influencer/campaigns', icon: <CampaignIcon /> },
  { label: 'Submissions', path: '/influencer/submissions', icon: <UploadIcon /> },
  { label: 'Profile', path: '/influencer/profile', icon: <PersonIcon /> },
]

/**
 * Bottom navigation for influencer mobile layout
 */
export const InfluencerBottomNav = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const currentIndex = navItems.findIndex((item) => {
    if (item.path === '/influencer') return location.pathname === '/influencer'
    return location.pathname === item.path || location.pathname.startsWith(`${item.path}/`)
  })
  const value = currentIndex >= 0 ? currentIndex : 0

  return (
    <Paper
      component="nav"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        borderTop: (t) => `1px solid ${t.palette.divider}`,
      }}
      elevation={8}
    >
      <BottomNavigation
        value={value}
        onChange={(_, newValue) => {
          const item = navItems[newValue]
          if (item) navigate(item.path)
        }}
        showLabels
        sx={{
          bgcolor: 'background.paper',
          '& .MuiBottomNavigationAction-root': {
            minWidth: 0,
            px: 0,
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.7rem',
          },
        }}
      >
        {navItems.map((item, idx) => (
          <BottomNavigationAction
            key={item.path}
            label={item.label}
            icon={item.icon}
            value={idx}
            aria-label={`Navigate to ${item.label}`}
          />
        ))}
      </BottomNavigation>
    </Paper>
  )
}
